
<template>
  <table width="100%"  border="1">
    <tr>
      <td>
        <table width="100%" border="0">
          <template v-for="(el, index) in realValue">
            <tr>
              <td>
                <input-select3 style="max-width: 50px;" @changed="changed" class="mt-1 col-1 px-0" v-model="el.TypeName" v-bind:options="[{Id:'',Text:'-'},{Id:'If',Text:'If'},{Id:'Before',Text:'Before created'},{Id:'After',Text:'After created'}]" idcolumnname="Id" textcolumnname="Text" />
                <input-select3 style="max-width: 50px; " @changed="changed" class="ml-1 mt-1 col-1 px-0" v-model="el.Source" v-bind:options="elements" idcolumnname="Id" textcolumnname="Text" />
                <input-select3 style="max-width: 30px;" @changed="changed" class="ml-1 mt-1 px-0" v-model="el.Requirement" v-bind:options="[{Id:'',Text:'-'},{Id:'Equals',Text:'='},{Id:'LessThan',Text:'<'},{Id:'MoreThan',Text:'>'},{Id:'LessThanOrEquals',Text:'<='},{Id:'MoreThanOrEquals',Text:'>='},{Id:'NotEquals',Text:'!='}]" idcolumnname="Id" textcolumnname="Text" />
                <input type="text" class="form-control ml-1 mt-1 col-2 px-0" v-model="el.SourceValue" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
                <input-select3 style="max-width: 50px; " @changed="changed" class="ml-1 mt-1 col-1 px-0" v-model="el.Action" v-bind:options="[{Id:'',Text:'-'},{Id:'Hide',Text:'Hide'},{Id:'Show',Text:'Show'},{Id:'Set',Text:'Set'},{Id:'Call',Text:'Call'},{Id:'Then',Text:'Then'},{Id:'Email',Text:'Email'},{Id:'Post',Text:'Post'}]" idcolumnname="Id" textcolumnname="Text" />
                <input-select3 style="max-width: 50px; " @changed="changed" class="ml-1 mt-1 col-1 px-0" v-show="el.Action != 'Call' && el.Action != 'Then' && el.Action != 'Mail'  && el.Action != 'Post'" v-model="el.Target" v-bind:options="elements" idcolumnname="Id" textcolumnname="Text" />
                <input type="text" class="ml-1 mt-1 form-control mt-1 px-1 col-2 px-0" v-show="el.Action == 'Hide' || el.Action == 'Show' || el.Action == 'Set' || el.Action == 'Call'" v-model="el.TargetValue" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
                <a href="#" @click="remove(el)"><i class="icon-subtract"></i></a>
              </td>
            </tr>
            <tr v-if="el.Action == 'Email'">
              <td>
                <conditions-mail v-bind:value="el" ref="procedureSchConditionsMail" @change="conditionsChanged"></conditions-mail>
              </td>
            </tr>
            <tr v-if="el.Action == 'Post'">
              <td>
                <conditions-post v-bind:value="el" ref="procedureSchConditionsPost" @change="conditionsChanged"></conditions-post>
              </td>
            </tr>
            <tr v-if="el.Action == 'Then'">
              <td>
                <conditions-element v-bind:showadvanced="false" v-bind:list="el.Conditions" class="ml-5" v-bind:showadd="true" ref="procedureSchConditionsChildren" @change="conditionsChanged"></conditions-element>
              </td>
            </tr>
          </template>
                 
        </table>
      </td>
    </tr>
    <tr v-if="showadd == true">
      <td>
        <conditions-add @add="addItem" />
      </td>
    </tr>
    <!--<tr v-if="showadvanced == true">
      <td>
        <div class="container-fluid">
          <div class="row mt-3">
            <div class="col-12">
              <container-expand-right title="Advanced" class="">
                <div class="container-fluid">
                  <div class="row mt-3" v-if="showadd == true">
                    <div class="col-12">
                      Use these functions to copy/paste
                    </div>
                    <div class="col-12 mt-1">
                      <a href="#" @click="getJsonData" class="btn-link btn skin primary-button">Get JSON</a>
                      <a href="#" @click="setJsonData" class="btn-link btn skin primary-button">Set JSON</a>
                    </div>
                  </div>
                  <div class="row my-3" v-if="showadd == true">
                    <div class="col-12">
                      <textarea class="form-control" v-model="contentJson"></textarea>
                    </div>
                  </div>
                </div>
              </container-expand-right>
            </div>
          </div>
        </div>
      </td>
    </tr>
    -->
  </table>
</template>

<script>
  export default {
    name: 'conditions-element',
    components: {
    },
    data(){
      return {
        contentJson: "",
        elements:['olle','bertil']
      }
    },
    props: {
      value: {
        required: false,
        type: Array,
        default() {
          return []
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      showadd: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
      showadvanced: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
    },
    methods: {
      getJsonData() {
        this.contentJson = JSON.stringify(this.realValue);
        return this.contentJson;
      },
      setJsonData() {
        this.value = JSON.parse(this.contentJson);
        this.$emit('change');
      },
      remove(el) {
        var elements = this.value;
        var itemIndex = -1;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i] == el) {
            itemIndex = i;
          }
        }
        this.realValue.splice(itemIndex, 1);
        this.$emit('change');
      },
      addItem(el) {
        this.realValue.push(el);
        this.$forceUpdate();
        this.$emit('change');
      },
      changed(el) {
        this.$forceUpdate();
        this.$emit('change');
      },
      setData(data) {
        var arrOfElements = this.getFlat(this.procedure.Elements, 0);
        this.elements = arrOfElements;
        this.value = data;
        Vue.set(this, "elements", this.elements);
        this.$forceUpdate();
      },
      getFlat(elements, level) {
        var arr = [];
        if (level == 0) {
          arr.push({ Id: '', Text: '-' })
          /*
          arr.push({ Id: 'Priority', Text: 'Priority' })
          arr.push({ Id: 'Status', Text: 'Status' })
          
          arr.push({ Id: 'Assigned', Text: 'Assigned' })
          arr.push({ Id: 'Location', Text: 'Location' })
          arr.push({ Id: 'Group', Text: 'Group' })
          arr.push({ Id: 'ProjectName', Text: 'Project' })
          //arr.push({ Id: 'TimeSpentHours', Text: 'Time spent hours' })
          */
          arr.push({ Id: 'Value', Text: 'Value' })
        }
        level++;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i].Text == "" || elements[i].Text == null)
            arr.push({ Id: elements[i].Id, Text: elements[i].Id.toString() });
          else
            arr.push({ Id: elements[i].Id, Text: elements[i].Text });
          var children = this.getFlat(elements[i].Elements, level);
          for (var k = 0; k < children.length; k++) {
            arr.push(children[k]);
          }
        }
        return arr;
      },
      getData(data) {
        return this.value;
      },
    },
  created() {
    
  },
    mounted() {
    },

    computed: {
      
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          this.$store.commit('saveprocedure', value)
        }
      },
      realValue() {
        return this.value;
      },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/conditions/conditions-element.vue